// extracted by mini-css-extract-plugin
export default {"home":"Home_home__099zF","container":"Home_container__VrywP","icon":"Home_icon__vGrJm","title":"Home_title__CfxFh","ha":"Home_ha__7FOVx"};